import { useState, useEffect } from 'react';
import moment from 'moment';
import papaparse from 'papaparse';
import i18n from '../../i18n';
import { useCurrentUser } from '../../providers/UserProvider';

const wordsPerMinute = 238;

export default function useSafetyShare(tbt) {
  const [safetyShare, setSafetyShare] = useState(null);
  const language = i18n.resolvedLanguage;
  const { user } = useCurrentUser();

  useEffect(() => {
    const getReadTime = (obj) => {
      const data = Object.entries(obj)
        .map(([key, value]) => `${key} ${value}`)
        .join(', ');
      const numWords = data.split(' ').length;
      return Math.ceil(numWords / wordsPerMinute) || 0;
    };

    if (tbt) {
      const readTime = getReadTime(tbt);
      setSafetyShare({ content: tbt, readTime });
    } else {
      const csvMap = {
        en: require('../../assets/toolbox_talks/en.csv'),
        'fr-CA': require('../../assets/toolbox_talks/fr-CA.csv'),
      };
      function resolveCsvLang(language) {
        const norm =
          user.locale || (language || '').replace('_', '-').toLowerCase();
        return norm.startsWith('fr') ? 'fr-CA' : 'en';
      }
      const fetchSafetyShares = async () => {
        const safetyShares = csvMap[resolveCsvLang(language)];
        papaparse.parse(safetyShares, {
          header: true,
          download: true,
          complete: ({ data }) => {
            const content = data[moment().dayOfYear() % data.length];
            const readTime = getReadTime(content);
            setSafetyShare({ content, readTime });
          },
        });
      };

      fetchSafetyShares();
    }
  }, [tbt, language, user.locale]);

  return safetyShare;
}
